import _slicedToArray from "/mnt/c/onesaz/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import Color from '../Color.js';
import { type } from '../utils/index.js';
Color.prototype.set = function (mc, value) {
  var mutate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _mc$split = mc.split('.'),
    _mc$split2 = _slicedToArray(_mc$split, 2),
    mode = _mc$split2[0],
    channel = _mc$split2[1];
  var src = this[mode]();
  if (channel) {
    var i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
    if (i > -1) {
      if (type(value) == 'string') {
        switch (value.charAt(0)) {
          case '+':
            src[i] += +value;
            break;
          case '-':
            src[i] += +value;
            break;
          case '*':
            src[i] *= +value.substr(1);
            break;
          case '/':
            src[i] /= +value.substr(1);
            break;
          default:
            src[i] = +value;
        }
      } else if (type(value) === 'number') {
        src[i] = value;
      } else {
        throw new Error("unsupported value for Color.set");
      }
      var out = new Color(src, mode);
      if (mutate) {
        this._rgb = out._rgb;
        return this;
      }
      return out;
    }
    throw new Error("unknown channel ".concat(channel, " in mode ").concat(mode));
  } else {
    return src;
  }
};